module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-stone-path-background.a96e334c.png";